// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1g4IJ3NRRm1xo1qTOK4l0g\\=\\={margin-top:8px;font-size:12px;line-height:14px;color:#72bf44;text-align:left}", "",{"version":3,"sources":["webpack://./shop/frontend/web/js/shared/addEmailNoticeForQuickSignup/style.module.css"],"names":[],"mappings":"AAAA,6BACC,cAAA,CAEA,cAAA,CACA,gBAAA,CACA,aAAA,CACA,eAAA","sourcesContent":[".emailNotice {\n\tmargin-top: 8px;\n\n\tfont-size: 12px;\n\tline-height: 14px;\n\tcolor: #72bf44;\n\ttext-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emailNotice": "_1g4IJ3NRRm1xo1qTOK4l0g=="
};
export default ___CSS_LOADER_EXPORT___;
